export default {
  "content": "<rect x=\"32\" y=\"80\" width=\"448\" height=\"256\" rx=\"16\" ry=\"16\" transform=\"rotate(180 256 208)\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M64 384h384M96 432h320\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"256\" cy=\"208\" r=\"80\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M480 160a80 80 0 01-80-80M32 160a80 80 0 0080-80m368 176a80 80 0 00-80 80M32 256a80 80 0 0180 80\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};